import { Map } from "immutable"

import {
    ROLE_LIST_REQUEST,
    STAKEHOLDERS_PAGE_ITEM_REQUEST
} from "../actions/action-types"
import { getRoleList } from "../api/role-api"
import { requestListEpic } from "./default-epics/default-entity-epics"
import {
    roleListCachedResponse,
    roleListErrorResponse,
    roleListRequest,
    roleListResponse
} from "../actions/role-actions"

export const requestRoleAfterStakeholderItemEpic = (action$, { getState }) =>
    action$.ofType(STAKEHOLDERS_PAGE_ITEM_REQUEST).map(action => {
        const state = getState()
        const string = `stakeholderID=${action.id}`
        const pagingRequest = state.paging.roles[string] || {
            searchCriteria: Map({
                stakeholderID: action.id
            })
        }

        return roleListRequest(pagingRequest)
    })

export const requestRoleListEpic = requestListEpic(
    ROLE_LIST_REQUEST,
    getRoleList,
    "roles",
    roleListResponse,
    roleListCachedResponse,
    roleListErrorResponse
)
